import { httpTokenCommon } from "../../helper/http-common";

class LogisticDashboardService {
  getLogisticTileCountsAPI(inputData) {
    return httpTokenCommon.post("Logistic/GetLogisticCount", inputData);
  }

  getLogisticDashboardTableListingAPI(inputData) {
    return httpTokenCommon.post("Logistic/GetLogisticsTabsData", inputData);
  }

  getShipmentOverviewAPI(inputData) {
    return httpTokenCommon.post("Logistic/GetShipmentOverview", inputData);
  }

  getShipmentMapViewAPI(inputData) {
    return httpTokenCommon.post("Logistic/GetShipmentMapView", inputData);
  }

  getShipmentTimelineAPI(inputData) {
    return httpTokenCommon.post("Logistic/GetShipmentTimeline", inputData);
  }

  getVesselInformationAPI(inputData) {
    return httpTokenCommon.post("Logistic/GetVesselInformation", inputData);
  }
}

const logisticDashboardService = new LogisticDashboardService();
export default logisticDashboardService;
